import axios from 'axios';
import { config } from '@ibk/shared-config';
import { ChannelEnum, } from '@ibk/shared-types';
export class TokenService {
    static async validateToken(request) {
        try {
            const response = await axios.post(`${config.apiBaseUrl}/v1/onboarding/token-validation`, request, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                const status = error.response?.status;
                if (status === 400) {
                    return {
                        status: 400,
                        result: false,
                        error: 'INVALID_CODE',
                    };
                }
                if (status === 401) {
                    return {
                        status: 401,
                        result: false,
                        error: 'AUTH_TOKEN_EXPIRED',
                    };
                }
                return {
                    status: status || 500,
                    result: false,
                    error: 'NETWORK_ERROR',
                };
            }
            return {
                status: 500,
                result: false,
                error: 'UNKNOWN_ERROR',
            };
        }
    }
    static async sendToken(request, channel) {
        try {
            const apiVersion = request.personId ? 'v1' : 'v2';
            const response = await axios.post(`${config.apiBaseUrl}/${apiVersion}/onboarding/resend-token`, {
                ...request,
                channel: channel === 'email' ? ChannelEnum.email : ChannelEnum.phone,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                const errorData = error.response?.data || {};
                throw new Error(errorData.message || 'Erro ao enviar token');
            }
            throw error;
        }
    }
}
